export default __webpack_public_path__ + "static/Pubblici-b6b411c7a396da97315207dd3f658cf3.jpg";